import { IAppState } from '../../common/state';

import { selectSpecialPromoBuilderOffers } from './selectSpecialPromoBuilderOffers';

export function selectIsSpecialProjectAdfoxBannerVisible(state: IAppState): boolean {
  const specialPromoBuilderOffers = selectSpecialPromoBuilderOffers(state);

  return !!specialPromoBuilderOffers?.needShowAdfoxBlock;
}
